import React from "react"
import { observer } from "mobx-react-lite"
import { useTheme, CSSObject } from "@emotion/react"
import { AppTheme } from "pitch45-common/theme/app-theme.types"
import { mediaQueries } from "pitch45-common/theme/layout"
import { unitSpacing } from "../../theme/spacing"
import PitchViewerPlaylistDetails from "./pitch-viewer-playlist-details"
import { PlaylistCoverImage } from "./playlist-cover-image"
import { EntityByline } from "../entity-byline/entity-byline"
import { useStores } from "pitch45-common/stores/root-store-context"

export function getStyles(theme: AppTheme) {
  const styles = {
    CONTAINER: {
      display: "flex",
      flexDirection: "row",
      flex: 1,
      justifyContent: "center",
      height: "100%",
      margin: "0 auto",
      width: "100%",
      gap: unitSpacing.double,
      [mediaQueries.TABLET]: {
        gap: unitSpacing.unit,
        flexDirection: "column",
        alignItems: "center",
      },
    },
    VIDEO_PLAYER: {
      position: "relative",
      marginTop: unitSpacing.unit,
      marginBottom: unitSpacing.unit,
      minWidth: 360,
      maxWidth: 500,
      width: "100%",
    },
    VIDEO_DETAILS: {
      margin: unitSpacing.unit,
      color: theme.colors.text,
      overflow: "hidden",
      maxWidth: 400,
      minWidth: 360,
    },
  }
  return styles as { [key in keyof typeof styles]: CSSObject }
}

export const PlaylistOverview = observer(function PitchViewer() {
  const { pitchViewerStore } = useStores()

  const theme = useTheme() as AppTheme
  const styles = getStyles(theme)

  const playlist = pitchViewerStore.playlist

  return (
    <div css={styles.CONTAINER}>
      {playlist && (
        <>
          <div css={styles.VIDEO_PLAYER}>
            <PlaylistCoverImage playlist={playlist} />
            <EntityByline
              containerStyle={{
                position: "absolute",
                top: "5%",
                left: "5%",
              }}
              entity={playlist.entity}
              size={"medium"}
              orientation={"horizontal"}
              displayEntityName={false}
            />
          </div>
          <div css={styles.VIDEO_DETAILS}>
            <PitchViewerPlaylistDetails playlist={playlist} hideCoverImage expanded />
          </div>
        </>
      )}
    </div>
  )
})
